import React, { FC } from 'react'
import { observer } from 'mobx-react'
import { payChannelMobx } from '@mobxStore'
import { IonHeader, IonModal } from '@ionic/react'
import CardConnectTokenizer from '../../component/Pay/BankCardOnline/Tokenizer/CardConnect'
import HeartlandTokenizer from '../../component/Pay/BankCardOnline/Tokenizer/Heartland'
import './index.scss'

interface IProps {
  payRechargeFlag?: boolean;
  multiUse?: boolean;
  resolve?: (card: TBankCardInfo) => void;
  reject?: () => void;
}

const BankCardAuthModal: FC<IProps> = ({ payRechargeFlag, multiUse, resolve, reject }) => {
  const onBackCardAuthorized = (card: TBankCardInfo) => {
    resolve(card)
  }

  return (
    <IonModal
      isOpen
      cssClass='bank-card-auth-modal'
      onDidDismiss={reject}
    >
      <IonHeader>
        <div className='bank-card-auth-header'>
          <span>{multiUse ? i18n.t('pay.addBankCard') : i18n.t('pay.inputBankCardInfo')}</span>
          <i className='iconfont icon-close' data-cypid='bankCardAuthModalCancel' onClick={reject} />
        </div>
      </IonHeader>
      {payChannelMobx.methodChannel.BankCardOnline?.channelType === 'CardConnectBankCard' && (
        <CardConnectTokenizer payRechargeFlag={payRechargeFlag} onAuthorize={onBackCardAuthorized} />
      )}
      {payChannelMobx.methodChannel.BankCardOnline?.channelType === 'HeartLandBankCard' && (
        <HeartlandTokenizer payRechargeFlag={payRechargeFlag} multiUse={multiUse} onAuthorize={onBackCardAuthorized} />
      )}
    </IonModal>
  )
}

export default observer(BankCardAuthModal)
